import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  defaultScaleProperties: {
    border: "1px solid #d9d9d4",
    padding:"15px",
  },
  radioPreview: {
    width: "100%",
  },
  warning: {
    color: "orange",
  },
});



// WEBPACK FOOTER //
// ./src/pages/admin/template-editor/components/template-settings/styles.ts